const saveVehicleCostPolicy = async ({ mode, validFrom, responsibilityAccepted = false } = {}) => {
  const policyTools = window.PlummeVehicleCostPolicy;
  if (!policyTools) throw new Error(t('r1e.vehicle.policyLoadFailed'));
  let savedPolicy = null;
  await updateStateAndPersist((state) => {
    savedPolicy = policyTools.applySelection(state.settings?.vehicleCostPolicy, {
      mode,
      validFrom,
      responsibilityAccepted,
    }, {
      confirmedAt: nowIso(),
      confirmedByUserId: runtime.user?.uid || '',
    });
    return {
      ...state,
      settings: {
        ...(state.settings || {}),
        vehicleCostPolicy: savedPolicy,
      },
    };
  });
  window.dispatchEvent(new Event('plumme-vehicle-cost-policy-changed'));
  return savedPolicy;
};
